import * as React from 'react';
import { getCounterValue } from './utils';
import styles from './Counter.module.css';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const Counter = _ref => {
  let {
    counter,
    counterMaxLength,
    className,
    dataTestId
  } = _ref;
  const counterValue = getCounterValue(counter, counterMaxLength);
  return /*#__PURE__*/_jsx("span", {
    className: clsx(styles['counter'], className),
    "data-testid": dataTestId,
    children: counterValue
  });
};